export const utf8ToBase64 = (string: string) => window.btoa(encodeURIComponent(string));

export const base64ToUtf8 = (string: string) => {
  return decodeURIComponent(window.atob(string));
};

export const getInitials = (value: string) => {
  if (!value.trim()) return '';

  const words = value.trim().split(/\s+/);

  const initials = words
    .map(word => {
      const firstLetter = word.match(/[A-Za-z]/);
      return firstLetter ? firstLetter[0].toUpperCase() : '';
    })
    .join('');

  return initials;
};
